import React from "react";
import ReactDOM from "react-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { useEditUserNameAndEmail } from "frontend/src/domain/user/model";
import { useUpdateUser } from "frontend/src/domain/user/actions";
import { queryClient } from "frontend/src/domain/query-client";
import { clientsCacheKey } from "frontend/src/domain/client/shared";
var FormDialog = function (_a) {
    var _b, _c;
    var isOpen = _a.isOpen, onClose = _a.onClose, initialValues = _a.initialValues, userId = _a.userId;
    var _d = useEditUserNameAndEmail({
        name: (_b = initialValues.name) !== null && _b !== void 0 ? _b : "",
        email: (_c = initialValues.email) !== null && _c !== void 0 ? _c : "",
    }), name = _d.name, email = _d.email, errors = _d.errors, validate = _d.validate;
    var _e = useUpdateUser(), update = _e.mutate, isSuccess = _e.isSuccess;
    var onNameChange = function (evt) {
        return name.set(evt.target.value);
    };
    var onEmailChange = function (evt) {
        return email.set(evt.target.value);
    };
    var submit = function (evt) {
        evt.preventDefault();
        if (validate()) {
            update({ id: userId, email: email.value, name: name.value });
        }
    };
    React.useEffect(function () {
        if (isSuccess) {
            queryClient.invalidateQueries(clientsCacheKey);
            onClose();
        }
    }, [isSuccess]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        React.createElement("form", { onSubmit: submit },
            React.createElement(DialogTitle, null, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E"),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { fullWidth: true, label: "Логин", value: name.value, onChange: onNameChange, error: Boolean(errors.name), helperText: errors.name }),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { fullWidth: true, label: "Почта", value: email.value, onChange: onEmailChange, error: Boolean(errors.email), helperText: errors.email }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { color: "primary", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
export var EditClientAccount = function (_a) {
    var name = _a.name, email = _a.email, userId = _a.userId;
    var _b = React.useState(false), isOpen = _b[0], setOpen = _b[1];
    var open = function () { return setOpen(true); };
    var close = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: "small", onClick: open },
            React.createElement(Edit, null)),
        ReactDOM.createPortal(React.createElement(FormDialog, { isOpen: isOpen, onClose: close, initialValues: { name: name, email: email }, userId: userId }), document.body)));
};
